// extracted by mini-css-extract-plugin
module.exports = {"base":"pageLink_base__37gX7","disabled":"pageLink_disabled__VUg6U"};